var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-row match-height"},[_c('div',{staticClass:"vx-col w-full"},[_c('vx-card',[_c('vs-tabs',{attrs:{"vs-alignment":"fixed","alignment":"fixed"}},[_c('div',[(
              _vm.$tabHasPermission(
                'GetAllBaseSalePricesByContract|GetItemsOfBaseSalePrice|CreateBaseSalePrice|AssignBaseSalePriceItems'
              )
            )?_c('vs-tab',{staticClass:"mt-6",attrs:{"label":_vm.$t('AvailableBaseSalePrices')}},[_c('available-base-sale-prices')],1):_vm._e()],1),_c('div',[(
              _vm.$tabHasPermission('GetAllHistoriesOfBaseSalePriceWithPageInfo')
            )?_c('vs-tab',{staticClass:"mt-6",attrs:{"label":_vm.$t('BaseSalePriceHistory')}},[_c('base-sale-price-history')],1):_vm._e()],1)])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }